(() => {
  "use strict";

  const storeLocation = "107926126918";
  const supplierLocation = "117426028870";
  const maxAge = 30 * 60 * 1000;
  const holidays = new Map();

  function calendarDate(value) {
    if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
    const date = new Date(`${value}T12:00:00Z`);
    return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value ? date : null;
  }

  function dateKey(date) {
    return date.toISOString().slice(0, 10);
  }

  function moveDays(date, days) {
    const result = new Date(date);
    result.setUTCDate(result.getUTCDate() + days);
    return result;
  }

  function swedishHolidays(year) {
    if (holidays.has(year)) return holidays.get(year);
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = (h + l - 7 * m + 114) % 31 + 1;
    const easter = new Date(Date.UTC(year, month - 1, day, 12));
    const dates = new Set(["01-01", "01-06", "05-01", "06-06", "12-25", "12-26"].map(value => `${year}-${value}`));
    [-2, 1, 39].forEach(offset => dates.add(dateKey(moveDays(easter, offset))));
    holidays.set(year, dates);
    return dates;
  }

  function addBusinessDays(value, count) {
    let date = calendarDate(value);
    if (!date || !Number.isInteger(count) || count < 0 || count > 10) return null;
    while (count > 0) {
      date = moveDays(date, 1);
      if (![0, 6].includes(date.getUTCDay()) && !swedishHolidays(date.getUTCFullYear()).has(dateKey(date))) count--;
    }
    return dateKey(date);
  }

  function stockholmToday(now) {
    const parts = new Intl.DateTimeFormat("en", { timeZone: "Europe/Stockholm", year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(now);
    const part = type => parts.find(value => value.type === type).value;
    return `${part("year")}-${part("month")}-${part("day")}`;
  }

  function locationQuantity(stock, locationId) {
    const location = Object.values(stock?.locations || {}).find(value => String(value?.locationId) === locationId);
    return Number.isSafeInteger(location?.available) ? location.available : null;
  }

  function evaluate(context, stock, now = new Date()) {
    const delivery = context?.delivery;
    if (!context || !["nukeproof", "ridley"].includes(context.supplier) || context.vendor !== context.supplier || context.enabled !== true) return null;
    if (context.supplier === "ridley" && [context.articleNumber, context.sku].some(value => /^CUSTOM-/i.test(value || ""))) return null;
    if (!delivery || delivery.version !== 1 || delivery.supplier !== context.supplier || delivery.date_confirmed !== false) return null;
    if (typeof delivery.article_number !== "string" || !delivery.article_number.trim() ||
        (context.articleNumber && delivery.article_number !== context.articleNumber) ||
        (context.supplier === "ridley" && /^CUSTOM-/i.test(delivery.article_number))) return null;
    if (typeof delivery.checked_at !== "string" || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,3})?Z$/.test(delivery.checked_at) ||
        !calendarDate(delivery.checked_at.slice(0, 10))) return null;
    const age = now.getTime() - Date.parse(delivery.checked_at);
    if (!Number.isFinite(age) || age < 0 || age > maxAge) return null;
    if (String(stock?.variantId).replace("gid://shopify/ProductVariant/", "") !== String(context.variantId)) return null;
    const store = locationQuantity(stock, storeLocation);
    if (store === null || store > 0) return null;
    const supplier = locationQuantity(stock, supplierLocation);
    if (delivery.status === "available" && delivery.dispatch_date === null && supplier > 0) return { status: "available" };
    if (delivery.status !== "expected" || supplier > 0 || !calendarDate(delivery.dispatch_date) || delivery.dispatch_date < stockholmToday(now)) return null;
    return {
      status: "expected",
      dispatch: delivery.dispatch_date,
      from: addBusinessDays(delivery.dispatch_date, 5),
      to: addBusinessDays(delivery.dispatch_date, 10),
    };
  }

  window.theme = window.theme || {};
  window.theme.bcfDelivery = { evaluate, addBusinessDays, calendarDate, locationQuantity, maxAge };
})();
